import { ampli } from '@src/analytics/ampli';
import { getAppEnv, getRuterHomeUrl } from '@src/utils';
import { Header } from '@web-common/ui/header';
import type { Links, NavigationLinks } from '@web-common/utils';
type Props = {
  lang: 'no' | 'en';
  headerLinks: Links[];
  primaryMenu: (Links | NavigationLinks)[];
  otherLangUrl?: string;
};

const HeaderWrapper = (props: Props) => {
  /**
   * This wrapper is needed in order to hydrate the onClick functions in the header
   */

  const ruternoHomeUrl = getRuterHomeUrl({
    lang: props.lang,
  });

  const changeLangUrl = (currentLang: 'en' | 'no', newUrl?: string | null) => {
    if (newUrl) {
      return `/${newUrl}`;
    }
    if (currentLang === 'en') {
      return '/';
    }
    return '/en';
  };
  const env = getAppEnv();
  
  return (
    <Header
      language={props.lang}
      headerLinks={props.headerLinks}
      primaryMenu={props.primaryMenu}
      env={env}
      loginUrl={`https://minside.ruter.no/`}
      searchUrl={`${ruternoHomeUrl}/sok`}
      logoUrl={ruternoHomeUrl}
      languageUrl={changeLangUrl(props.lang, props.otherLangUrl)}
      domain={ruternoHomeUrl}
      onClickTracking={(analyticsEvent: any) => {
        ampli.ruterNoMenuItemSelected({ item: analyticsEvent });
      }}
      onToggleClickTracking={(theme: any) => {
        ampli.ruterNoMenuToggleTheme({ theme });
      }}
    />
  );
};
export { HeaderWrapper };
